import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MessageInput from './MessageInput';
import MessageBubble from './MessageBubble';
import { FaUser, FaBars, FaUserPlus, FaCheck, FaTimes } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import './ChatWindow.scss';
import fnc from '../../mymod/commFunction';
import { getCanonicalTalkUserId } from '../talkUserId';
//이것의 부모는? src/page_firebase/ChatWindowPage.js
const ChatWindow = ({ 
  chatroom, 
  messages, 
  currentUser, 
  userProfile,
  onSendMessage,
  onAddParticipants,
  onRemoveParticipant,
  messagesEndRef,
  onGoBack,
  unreadCount = 0  // 전체 채팅방 안읽음 (사용 안 함)
}) => {
  const navigate = useNavigate();
  const chatContainerRef = useRef(null);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  
  // Redux에서 사용자 정보 가져오기
  const userInfo = useSelector((state) => state.reduxStore.userInfo);
  const userInfo2 = useSelector((state) => state.reduxStore.userInfo2);
  
  // 현재 로그인한 실제 사용자 ID
  const academyCode = userInfo2?.acaCode || fnc.getCookie('acaCode') || '';
  const currentUserId = getCanonicalTalkUserId(userInfo2, userInfo, academyCode) || currentUser?.uid;

  // 참여자 추가 모달 열기 (1:1 채팅 차단)
  const handleOpenAddUserModal = () => {
    if (chatroom?.type === 'direct') {
      alert('1:1 채팅방에는 참여자를 추가할 수 없습니다.');
      return;
    }
    setShowAddUserModal(true);
  };

  // 메시지가 업데이트될 때 스크롤 위치 관리
  useEffect(() => {
    if (chatContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;
      
      if (isNearBottom) {
        scrollToBottom();
      }
    }
  }, [messages]);

  // // 사용자 목록 로드
  // const loadUsers = () => {
  //   fnc.sendAxios('/socialLoginRoutes/select/allUsers', {}, (res) => {
  //     if (res && Array.isArray(res)) {
  //       // 이미 채팅방에 참여 중인 사용자 제외
  //       const currentParticipants = chatroom?.participants || [];
  //       const availableUsers = res.filter(user => !currentParticipants.includes(user.id));
  //       setUsers(availableUsers);
  //     }
  //   });
  // };

  
  // 사용자 목록 로드
  const loadUsers = () => {
    fnc.sendAxios('/socialLoginRoutes/select/allUsers2', {acaCode: userInfo2?.acaCode}, (res) => {
      if (res && Array.isArray(res)) {
        // 이미 채팅방에 참여 중인 사용자 제외
        const currentParticipants = chatroom?.participants || [];
        const availableUsers = res.filter(user => !currentParticipants.includes(user.id));
        setUsers(availableUsers);
      }
    });
  };


  // 모달 열 때 사용자 목록 로드
  // useEffect(() => {
  //   if (showAddUserModal) {
  //     loadUsers();
  //   }
  // }, [showAddUserModal, chatroom?.participants]);

  useEffect(() => {
    if (showAddUserModal) {
      loadUsers();
    }
  }, [showAddUserModal]);

  // 사용자 선택/해제
  const toggleUserSelection = (userId) => {
    setSelectedUsers(prev => 
      prev.includes(userId) 
        ? prev.filter(id => id !== userId)
        : [...prev, userId]
    );
  };

  // 검색 필터링
  const filteredUsers = users.filter(user => 
    !searchKeyword || 
    user.nickname?.toLowerCase().includes(searchKeyword.toLowerCase()) ||
    user.id?.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  // 참여자 추가 처리
  const handleAddParticipants = async () => {
    if (selectedUsers.length > 0 && onAddParticipants) {
      console.log('참여자 추가 시작:', selectedUsers);
      console.log('채팅방 ID:', chatroom?.id);
      
      try {
        await onAddParticipants(selectedUsers, chatroom?.id);
        console.log('✅ 참여자 추가 완료');
        
        // 모달 닫기 및 초기화
        setSelectedUsers([]);
        setSearchKeyword('');
        setShowAddUserModal(false);
      } catch (error) {
        console.error('❌ 참여자 추가 실패:', error);
        alert('참여자 추가에 실패했습니다: ' + (error.message || '알 수 없는 오류'));
      }
    } else {
      setShowAddUserModal(false);
    }
  };

  // 메시지 소유권 확인 - 실제 사용자 ID 기반 (useCallback으로 최적화)
  const isOwnMessage = useCallback((senderId) => {
    return senderId === currentUserId || senderId === currentUser?.id;
  }, [currentUserId, currentUser?.id]);

  // 사용자 이름 가져오기 (useCallback으로 최적화)
  const getUserDisplayName = useCallback((senderId, originalSenderName) => {
    if (isOwnMessage(senderId)) {
      return userProfile?.nickname || userProfile?.name || originalSenderName || '나';
    }
    return originalSenderName || '익명';
  }, [isOwnMessage, userProfile?.nickname, userProfile?.name]);

  // 메시지 안읽음 상태 계산 (카카오톡 스타일)
  const getMessageUnreadCount = (message) => {
    // 내가 보낸 메시지가 아니면 안읽음 표시 안 함
    if (message.senderId !== currentUserId) {
      return 0;
    }

    // 채팅방 참여자가 없으면 0
    if (!chatroom?.participants || chatroom.participants.length <= 1) {
      return 0;
    }

    // 나를 제외한 다른 참여자들 중 이 메시지를 안 읽은 사람 수 계산
    let unreadCount = 0;
    const messageTimestamp = message.timestamp;

    chatroom.participants.forEach(participantId => {
      // 자신은 제외
      if (participantId === currentUserId) return;

      // 상대방의 마지막 읽은 시간
      const lastReadTime = chatroom.lastReadTimestamp?.[participantId] || 0;

      // 메시지 시간이 상대방의 마지막 읽은 시간보다 나중이면 안 읽음
      if (messageTimestamp > lastReadTime) {
        unreadCount++;
      }
    });

    return unreadCount;
  };

  const scrollToBottom = useCallback(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messagesEndRef]);

  // 날짜별로 메시지 그룹화 (useCallback으로 최적화)
  const groupMessagesByDate = useCallback((messages) => {
    const groups = {};
    
    messages.forEach(message => {
      const messageDate = message.timestamp?.toDate ? 
        message.timestamp.toDate() : 
        new Date(message.timestamp);
      
      const dateKey = messageDate.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long'
      });
      
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(message);
    });
    
    return groups;
  }, []);

  // 연속된 같은 사용자 메시지 그룹화 (useCallback으로 최적화)
  const groupConsecutiveMessages = useCallback((messages) => {
    const groups = [];
    let currentGroup = null;
    
    messages.forEach(message => {
      if (!currentGroup || currentGroup.senderId !== message.senderId) {
        if (currentGroup) {
          groups.push(currentGroup);
        }
        currentGroup = {
          senderId: message.senderId,
          senderName: message.senderName,
          messages: [message],
          timestamp: message.timestamp
        };
      } else {
        currentGroup.messages.push(message);
      }
    });
    
    if (currentGroup) {
      groups.push(currentGroup);
    }
    
    return groups;
  }, []);

  // useMemo로 메시지 그룹화 최적화
  const messageGroups = useMemo(() => groupMessagesByDate(messages), [messages, groupMessagesByDate]);

  return (
    <div className="chat-window">
      {/* 채팅방 헤더 */}
      <div className="chat-header">
        <div className="chat-header-info">
          <div className="chatroom-avatar">
            <div className="avatar-circle">
              {chatroom.name.charAt(0).toUpperCase()}
            </div>
          </div>
          <div className="chatroom-details">
            <h4>{chatroom.name}</h4>
            <p className="participant-count">
              <FaUser size={10} /> {chatroom.participants?.length || 0}
            </p>
          </div>
        </div>
        
        <div className="chat-header-actions">
          <button 
            className="header-action-btn" 
            onClick={handleOpenAddUserModal}
            title="참여자 추가"
          >
            <FaUserPlus size={16} />
          </button>

          <button className="close-btn" onClick={() => navigate(-1)} title="닫기">
            <AiOutlineClose size={16} />
          </button>
        </div>
      </div>

      {/* 메시지 영역 */}
      <div className="chat-messages" ref={chatContainerRef}>
        {Object.keys(messageGroups).length === 0 ? (
          <div className="no-messages">
            <p>아직 메시지가 없습니다.</p>
            <p>첫 번째 메시지를 보내보세요! 👋</p>
          </div>
        ) : (
          Object.entries(messageGroups).map(([date, dateMessages]) => (
            <div key={date} className="message-date-group">
              <div className="date-separator">
                <span>{date}</span>
              </div>
              
              {groupConsecutiveMessages(dateMessages).map((group, groupIndex) => {
                const isOwn = isOwnMessage(group.senderId);
                
                return (
                <div 
                  key={`${date}-${groupIndex}`} 
                  className={`message-group ${isOwn ? 'own-message' : 'other-message'}`}
                >
                  {/* 다른 사용자 메시지인 경우 프로필 정보 표시 */}
                  {!isOwn && (
                    <div className="message-sender">
                      <div className="sender-avatar">
                        {getUserDisplayName(group.senderId, group.senderName)?.charAt(0).toUpperCase() || '?'}
                      </div>
                      <span className="sender-name">
                        {getUserDisplayName(group.senderId, group.senderName)}
                      </span>
                    </div>
                  )}
                  
                  {/* 메시지 버블들 */}
                  <div className="message-bubbles">
                    {group.messages.map((message, index) => {
                      const isLastMessageInGroup = index === group.messages.length - 1;
                      // 전체 메시지에서 마지막인지 확인 (메시지 ID를 기준으로)
                      const lastMessage = messages[messages.length - 1];
                      const isLastMessage = lastMessage && message.id === lastMessage.id;
                      // 각 메시지별 안읽음 개수 계산
                      const messageUnreadCount = getMessageUnreadCount(message);
                      
                      return (
                        <MessageBubble
                          key={message.id}
                          message={message}
                          isOwn={isOwn}
                          showTime={isLastMessageInGroup}
                          unreadCount={messageUnreadCount}
                          isLastMessage={isLastMessage}
                        />
                      );
                    })}
                  </div>
                </div>
                );
              })}
            </div>
          ))
        )}
        
        <div ref={messagesEndRef} />
      </div>

      {/* 메시지 입력 영역 */}
      <MessageInput 
        onSendMessage={onSendMessage}
      />

      {/* 참여자 추가 모달 */}
      {showAddUserModal && (
        <div className="modal-overlay" onClick={() => setShowAddUserModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>참여자 관리</h3>
              <button 
                className="modal-close-btn" 
                onClick={() => setShowAddUserModal(false)}
              >
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              {/* 현재 참여자 목록 */}
              <div className="current-participants-section">
                <h4>현재 참여자 ({chatroom.participants?.length || 0}명)</h4>
                <div className="current-participants-list">
                  {chatroom.participants && chatroom.participants.map((participantId) => {
                    const isMe = participantId === currentUserId;
                    const isCreator = participantId === chatroom.createdBy;
                    const idParts = participantId.split('_');
                    const displayId = idParts.length > 1 ? idParts[1] : participantId;
                    
                    return (
                      <div key={participantId} className="participant-item">
                        <div className="participant-info">
                          <FaUser size={12} />
                          <span className="participant-id">{displayId}</span>
                          {isMe && <span className="me-badge">나</span>}
                          {isCreator && <span className="creator-badge">방장</span>}
                        </div>
                        {!isMe && onRemoveParticipant && chatroom.type !== 'direct' && (
                          <button
                            className="remove-participant-btn"
                            onClick={() => onRemoveParticipant(participantId)}
                            title="내보내기"
                          >
                            <FaTimes size={12} />
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* 새 참여자 추가 */}
              <div className="add-participants-section">
                <h4>새 참여자 추가</h4>
                <input
                  type="text"
                  placeholder="사용자 검색..."
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  className="search-input"
                />

                <div className="selected-count">
                  {selectedUsers.length}명 선택됨
                </div>

              <div className="users-list">
                {filteredUsers.length === 0 ? (
                  <p className="no-users">
                    {users.length === 0 ? '추가할 수 있는 사용자가 없습니다.' : '검색 결과가 없습니다.'}
                  </p>
                ) : (
                  filteredUsers.map((user, index) => (
                    <div
                      key={user.id}
                      className={`user-item ${selectedUsers.includes(user.id) ? 'selected' : ''}`}
                      onClick={() => toggleUserSelection(user.id)}
                    >
                    
                      <div className="user-info">
                        <span className="user-no">{index + 1}</span>
                        <span className="user-nickname">{user.nickname}</span>
                        <span className="user-id">( {user.id2} )</span>
                      </div>
                      {selectedUsers.includes(user.id) && (
                        <FaCheck className="check-icon" />
                      )}
                    </div>
                  ))
                )}
              </div>
              </div>
            </div>

            <div className="modal-footer">
              <button 
                className="cancel-btn" 
                onClick={() => {
                  setShowAddUserModal(false);
                  setSelectedUsers([]);
                  setSearchKeyword('');
                }}
              >
                취소
              </button>
              <button 
                className="confirm-btn" 
                onClick={handleAddParticipants}
                disabled={selectedUsers.length === 0}
              >
                추가 ({selectedUsers.length})
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWindow;
